import TerminHistoriaZmien from './TerminHistoriaZmien';

export default TerminHistoriaZmien;
